
import {Component, Vue} from "vue-property-decorator";
import {formRules} from "@/utils/formRules";

@Component({
  components: {},
})
export default class PreviewBoxes extends Vue {

  private currentBoxes: any = [];
  private qrCodeBoxes: any = [];
  private headers: object[] = [];
  private search: string = "";
  private loading: boolean = false;
  private saving: boolean = false;
  private rules: object = formRules;

  private mounted() {
    this.headers = [
      {value: "informations", sortable: false},
      {value: "buildingName", text: this.$t("import.boxes.columns.buildingName"), sortable: true},
      {value: "buildingId", text: this.$t("import.boxes.columns.buildingId"), sortable: true},
      {value: "boxNumber", text: this.$t("import.boxes.columns.boxNumber"), sortable: true},
      {value: "boxName", text: this.$t("import.boxes.columns.boxName"), sortable: true},
      {value: "locationNb", text: this.$t("import.boxes.columns.locationNb"), sortable: true},
    ];
    this.reset();
    if (!this.currentBoxes || (this.currentBoxes && this.currentBoxes.length) === 0) {
      this.$router.push({name: "home"});
    }
  }

  private reset(): void {
    this.currentBoxes = JSON.parse(JSON.stringify(this.$route.params.items));
  }

  // Reset one box property to the import value
  // If no property is specified, reset all box's properties to the import values
  private resetBoxProperty(box: any, property?: string): void {
    if (property) {
      box.currentValues[property] = box.importValues[property];
      box.duplicate = false;
    } else {
      Object.keys(box.currentValues).forEach((prop) => {
        box.currentValues[prop] = box.importValues[prop];
        box.duplicate  = false;
      });
    }
  }

  private checkDuplicates(box: any) {
      const duplicateFn = (b) => Number(b.currentValues.boxNumber) === Number(box.currentValues.boxNumber)
        && Number(b.currentValues.buildingId) === Number(box.currentValues.buildingId);
      const firstIndex = this.currentBoxes.findIndex(duplicateFn);
      const lastIndex = this.currentBoxes.findLastIndex(duplicateFn);
      box.duplicate = firstIndex !== lastIndex;
  }

  private searchCurrentValues(value, search, item) {
    for (const key of Object.keys(item.currentValues)) {
      if (item.currentValues[key].includes(search)) {
        return true;
      }
    }
    return false;
  }

  private getChipColor(item: any, property: string): string {
    if (item.databaseDuplicate) {
      return "red";
    } else if (item.duplicate) {
      return "grey";
    } else if (item.currentValues[property] !== item.importValues[property]) {
      return "warning";
    } else {
      return "default";
    }
  }

  private getChipTextColor(item: any, property: string): string {
    if (item.databaseDuplicate) {
      return "red";
    } else if (item.duplicate) {
      return "grey";
    } else if (item.currentValues[property] !== item.importValues[property]) {
      return "warning";
    } else {
      return "default";
    }
  }

  private deleteBox(box): void {
    if (confirm(this.$t("import.boxes.deleteConfirmation").toString())) {
      const pos = this.currentBoxes.map((u) => u.importId).indexOf(box.importId);
      this.currentBoxes.splice(pos, 1);
    }
  }

  private importBoxes(): void {
    this.currentBoxes.forEach((box) => {
      // If "createQrCodeBox" is ticked, assign value
      box.currentValues.createQrCodeBox = this.qrCodeBoxes.map((b) => b.importId).includes(box.importId);
    });
    this.saving = true;
    this.$store.dispatch("boxes/import", {
      boxes: this.currentBoxes.map((b) => b.currentValues),
    })
      .then((data) => {
        this.$store.commit("alerts/displaySuccess", {
          msg: this.$t("import.boxes.success"),
        });
        this.$router.push({name: "buildings", params: {data}});
      })
      .catch((error) => {
        this.$store.commit("alerts/displayHttpError", { error });
      })
      .finally(() => {
        this.saving = false;
      });
  }
}
